import clsx from 'clsx';
import { AmenityItem, AmenityLabel, IconWrapper } from './Amenity.styles';
import { AmenityProps } from './Amenity.types';
import { parseIconClass } from './utils';

export function Amenity({ className, iconClass, label }: AmenityProps) {
  const splitLabel = () => {
    const trimmedLabel = label?.trim().split(/\s+/);
    const lastWord = trimmedLabel?.pop();
    return [trimmedLabel?.join(' '), lastWord];
  };
  const [firstLine, secondLine] = splitLabel();
  return (
    <AmenityItem className={className}>
      <IconWrapper>
        <span className={clsx('icon', parseIconClass(iconClass))} />
      </IconWrapper>
      {label ? (
        <div className="d-flex flex-column">
          <AmenityLabel className="t-font-alt-xs fw-bold">{firstLine}</AmenityLabel>
          <AmenityLabel className="t-font-alt-xs fw-bold">{secondLine}</AmenityLabel>
        </div>
      ) : null}
    </AmenityItem>
  );
}
